import { setLiveGuidelineCookie } from '../redux/persistedState';

// Params of the search TC reported last time, so Edit reopens TC with the same filters selected.
const getSavedSearchParams = (criteria: Array<{ filterValue: string }>): URLSearchParams => {
    try {
        const returnUrl: string | undefined = JSON.parse(
            criteria[0]?.filterValue,
        )?.catalogSearchReturnUrl;
        return new URLSearchParams(returnUrl?.split('?')[1] ?? '');
    } catch {
        return new URLSearchParams();
    }
};

export const openCatalogForLiveGuideline = (
    liveGuidelineId: number,
    criteria: Array<{ filterValue: string }> = [],
) => {
    const params = getSavedSearchParams(criteria);
    params.set('liveGuideline', String(liveGuidelineId));
    // In development the SPA's own /search page stands in for Transparency Catalog.
    const baseUrl =
        process.env.NODE_ENV === 'development'
            ? process.env.REACT_APP_URL
            : process.env.REACT_APP_TC_URL;
    setLiveGuidelineCookie(true);
    window.location.href = `${baseUrl}/search?${params.toString()}`;
};
